import { useEffect } from 'react';
import { API_URL } from '../config';

/**
 * SeoMetaInjector - Fetches SEO meta data from backend and injects into HTML head.
 * Uses the public /api/seo-meta endpoint (no auth required).
 * Renders nothing — purely a side-effect component.
 */
export default function SeoMetaInjector() {
  useEffect(() => {
    let cancelled = false;

    const injectSeoMeta = async () => {
      try {
        const res = await fetch(`${API_URL}/api/seo-meta`);
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;

        // Update meta description
        if (data.meta_description) {
          const descTag = document.querySelector('meta[name="description"]');
          if (descTag) descTag.setAttribute('content', data.meta_description);
        }

        // Update meta keywords
        if (data.keywords && data.keywords.length > 0) {
          let keywordsTag = document.querySelector('meta[name="keywords"]');
          if (keywordsTag) {
            keywordsTag.setAttribute('content', data.keywords.join(', '));
          }
        }

        // Update OG tags
        if (data.meta_title) {
          const ogTitle = document.querySelector('meta[property="og:title"]');
          if (ogTitle) ogTitle.setAttribute('content', data.meta_title);

          const twitterTitle = document.querySelector('meta[name="twitter:title"]');
          if (twitterTitle) twitterTitle.setAttribute('content', data.meta_title);
        }

        if (data.og_description) {
          const ogDesc = document.querySelector('meta[property="og:description"]');
          if (ogDesc) ogDesc.setAttribute('content', data.og_description);

          const twitterDesc = document.querySelector('meta[name="twitter:description"]');
          if (twitterDesc) twitterDesc.setAttribute('content', data.og_description);
        }

      } catch (error) {
        // Silent fail — static meta tags in index.html remain as fallback
        console.debug('SEO meta injection skipped:', error.message);
      }
    };

    injectSeoMeta();

    return () => { cancelled = true; };
  }, []);

  return null;
}
